import { render, staticRenderFns } from "./NewCharges.vue?vue&type=template&id=3e3bece0&scoped=true"
import script from "./NewCharges.vue?vue&type=script&lang=js"
export * from "./NewCharges.vue?vue&type=script&lang=js"
import style0 from "./NewCharges.vue?vue&type=style&index=0&id=3e3bece0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e3bece0",
  null
  
)

export default component.exports